import { Button } from "@heroui/button";
import { Badge } from "@heroui/badge";
import { Tooltip } from "@heroui/tooltip";
import { Inbox, Loader } from "lucide-react";

import { useRequests } from "@/features/Admin/Admin.api.ts";

interface NotificationsProps {
  showRequests: boolean;
  setShowRequests: (value: boolean) => void;
  requests: number;
  setShowNotifications: (value: boolean) => void;
  onOpen: () => void;
}

const InboxRequests = ({
  requests,
  setShowRequests,
  showRequests,
  setShowNotifications,
  onOpen,
}: NotificationsProps) => {
  const { error, isLoading } = useRequests();

  if (error) {
    return <div>Error fetching notifications: {error.message}</div>;
  }

  const toggle = () => {
    setShowRequests(!showRequests);
    setShowNotifications(false);
    onOpen();
  };

  return (
    <Tooltip content="Requests From Farmers">
      <Button
        isIconOnly
        aria-label="requests"
        endContent={
          <Badge
            color="success"
            content={isLoading ? <Loader /> : requests}
            shape="circle"
            size={"sm"}
          >
            <Inbox className="fill-current" size={19} />
          </Badge>
        }
        radius="full"
        size={"lg"}
        variant="light"
        onPress={toggle}
      />
    </Tooltip>
  );
};

export default InboxRequests;
